<template>
    <ideo-form-group class="mt-3" :label="$t('[[[Wybierz tagi]]]')">
        <ideo-autocomplete
            v-model="selectedTag"
            name="selectedTag"
            track-by="publicId"
            :placeholder="$t('[[[Zacznij pisać aby wyszukać tagi...]]]')"
            :fetch="(publicId) => fetchAutocompleteModelByPublicId(publicId)"
            :search="(query: string, limit: number) => getAutocompleteList(query, limit)"
            @update:modelValue="addTag()"
        >
            <template #selected="{ option }">
                <div class="d-flex flex-nowrap align-items-center">
                    <b class="ml-2">{{ option.name }}</b>
                </div>
            </template>
            <template #option="{ option }">
                <div class="d-flex flex-nowrap align-items-center">
                    <b class="ml-2">{{ option.name }}</b>
                </div>
            </template>
        </ideo-autocomplete>
    </ideo-form-group>
    <ideo-form-group :label="$t('[[[Przypisane tagi:]]]')">
        <div class="alert alert-dark" v-if="!tags.length">
            {{ $t('[[[Brak przypisanych tagów.]]]') }}
        </div>
        <div v-else class="row">
            <div class="col">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item bg-light" v-for="(item) in tags" :key="item.publicId.toString()">
                        <div class="d-flex flex-nowrap align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                                <i class="fas fa-list-check"></i>
                                <b class="ml-2">{{ item.name }}</b>
                            </div>
                            <a class="btn" @click="removeTag(item[trackBy])">
                                <i class="fas fa-minus-circle"></i>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import TasksTagsService, { ListItemModel, TaskTagName } from '@/modules/renter/tasksTags/services/TasksTagsService';
import { Prop, Watch } from '@/helpers/Decorators';

type ModelValue = number | string;

@Options({
    name: 'FormTasksTags',
    components: {},
    emits: ['addTag', 'removeTag', 'watchBOK', 'onLoading']
})
export default class FormTasksTags extends Vue
{
    @Prop() public modelValue: ModelValue[];
    @Prop({ default: 'publicId' }) public trackBy: 'publicId' | 'id';
    @Prop({ default: false }) public watchBOK: boolean;

    public value: ModelValue[] = [];

    protected selectedTag: string = null;
    protected tags: ListItemModel[] = [];

    public async addTag(): Promise<void>
    {
        if (this.selectedTag === null) return;

        this.$emit('onLoading', true);

        const tag = await this.handleFetchTag(this.selectedTag);

        this.selectedTag = null;

        if (this.value.includes(tag[this.trackBy]))
        {
            this.$emit('onLoading', false);

            return;
        }

        this.tags.push(tag);
        this.value.push(tag[this.trackBy]);
        this.update();
        this.selectedTag = null;
        this.$emit('onLoading', false);
    }

    public removeTag(id: number | string): void
    {
        const index = this.tags.findIndex((tag: ListItemModel) => tag[this.trackBy] === id);

        if (index === -1) return;

        this.tags.splice(index, 1);
        this.value.splice(index, 1);
        this.update();
    }

    @Watch('tags')
    public onTagsChange(): void
    {
        if (this.watchBOK)
        {
            const isBOKSelected = this.tags.filter((tag: ListItemModel) => tag.name === TaskTagName.BOK).length > 0;

            this.$emit('watchBOK', isBOKSelected);
        }
    }

    public update(): void
    {
        this.onTagsChange();
        this.$emit('update:modelValue', this.value);
    }

    public handleFetchTag(id: number | string): Promise<ListItemModel>
    {
        if ( typeof id === "string")
            return TasksTagsService.fetchAutocompleteModelByPublicId(id as string);
        else
            return TasksTagsService.fetchAutocompleteModelById(id as number);
    }

    @Watch('modelValue', { immediate: true})
    public async onModelValueChange(): Promise<void>
    {
        this.value = this.modelValue;

        this.tags = await Promise.all(this.modelValue.map((id) => this.handleFetchTag(Number(id))));
    }


    protected getAutocompleteList = TasksTagsService.getAutocompleteList;
    protected fetchAutocompleteModelById = TasksTagsService.fetchAutocompleteModelById;
    protected fetchAutocompleteModelByPublicId = TasksTagsService.fetchAutocompleteModelByPublicId;
}
</script>
